import { FormGroup } from '@angular/forms';
import { IStoreDocument } from '../model';
import { StringHelper } from "./stringHelper";

export abstract class FormHelper {

  //#region METHODS

  public static canBeFilled(pbOneTimeFilled: boolean, poModel: IStoreDocument, poValue: any): boolean {
    if (!pbOneTimeFilled)
      return true;
    else if (typeof poValue === "string")
      return StringHelper.isBlank(poValue);
    else
      return !poModel._rev || !poValue;
  }

  public static removeSpaces(value: string): string {
    return value.replace(/\s+/g, '');
  }

  public static removeSpacesFromInput(event: Event, form: FormGroup, inputName: string): void {
    const inputElement = event.target as HTMLInputElement;
    const newValue = FormHelper.removeSpaces(inputElement.value);

    if (newValue !== inputElement.value) {
      form.get(inputName)?.setValue(newValue, { emitEvent: false });
    }
  }


	public static validSizeInput(event: Event, form: FormGroup, inputName: string,max: number): void {
    const maxLength = max;
    const input = form.get(inputName);
    if (input) {
      let value = input.value;
      value = value.substring(0, maxLength);
      input.setValue(value, { emitEvent: false });
		}
	}

  /**
   * Valide et formate l'entrée FINESS, applique la validation Luhn.
   */
  public static validFinessInput(event: Event, form: FormGroup, inputName: string): void {
    const maxLength = 9;
    this.removeSpacesFromInput(event, form, inputName);
    const input = form.get(inputName);
    if (input) {
      let value = input.value;
      // Garder uniquement chiffres (FINESS = 9 chiffres)
      value = value.replace(/[^0-9]/g, '').substring(0, maxLength);
      input.setValue(value, { emitEvent: false });

      // Validation FINESS Luhn
      const isValid = this.isValidFinessLuhn(value);

      if (!isValid) {
        input.setErrors({ invalidFiness: true });
      } else {
        if (input.hasError('invalidFiness')) {
          const errors = input.errors;
          if (errors) {
            delete errors.invalidFiness;
            if (Object.keys(errors).length === 0) {
              input.setErrors(null);
            } else {
              input.setErrors(errors);
            }
          }
        }
      }
    }
  }

  /**
   * Valide un code CPS (4 chiffres max).
   */
  public static validCPSCode(code: string): string {
    return code.replace(/\D/g, '').slice(0, 4);
  }

  /**
   * Validation Luhn pour numéro FINESS :
   * - 9 chiffres
   * - clé de contrôle Luhn (mod 10)
   */
  public static isValidFinessLuhn(finess: string): boolean {
    if (finess.length !== 9) return false;

    let sum = 0;
    let doubleDigit = false;

    for (let i = finess.length - 1; i >= 0; i--) {
      let digit = parseInt(finess[i], 10);
      if (doubleDigit) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      doubleDigit = !doubleDigit;
    }
    return sum % 10 === 0;
  }

  //#endregion

}
